<template>
  <TransitionGroup
    tag="ul"
    :css="false"
    class="no-scrollbar list-inside overflow-scroll text-white"
  >
    <li
      v-for="n in 14"
      :key="n"
      class="w-full py-3"
    >
      <USkeleton class="rounded-lg bg-[--theme-darkest]" />
    </li>
  </TransitionGroup>
</template>
